import React from 'react';
import styled from "styled-components";
import {Plural} from "@lingui/macro";

const Styled = styled.div`
  margin-right: 16px;
  font-weight: 600;
  line-height: 32px;
`;

/**
 * Props:
 * - rowIdList: Int[] of ids selected fr bulk actions
 */
export function SelectedItemDiv(props) {
    const { selectedIds, showZeroSelected } = props;

    if (selectedIds.length || showZeroSelected) {
        return (
            <Styled>
                <Plural value={selectedIds.length} one="1 item selected" other="# items selected" />
            </Styled>
        );
    }
    return null;
}
